<div class="common-modal__container">
  <div class="common-modal__header">
    <span
      class="common-modal__text-header"
      afTranslate="snippets-reusable.new-snippet-text">
      _Nuevo bloque de texto
    </span>
  </div>
  <div class="common-modal__content">
    <p class="common-modal__content-header-info"
      afTranslate="snippets-reusable.new-snippet-info">
      _El fragmento seleccionado se guardará en el listado de “Textos reutilizables”. Puedes acceder a este listado desde el botón de “Configuraciones” de la cabecera.
    </p>
    <div class="common-modal__form-container">
      <div class="common-container__mandatory-obligatory-message-form">
        <span class="common-tag__mandatory-text-asterisk">*</span>
        <span
          class="common-tag__mandatory-label-text-obligatory-message"
          afTranslate="common.required-fields">
          _Campos obligatorios
        </span>
      </div>
      <field-type-text-simple
        [field]="shortIdField"
        [preSelectItem]="snippet.shortId"
        (itemSelected)="itemSelected($event.newValue, shortIdField, 'shortId')">
      </field-type-text-simple>
      <field-type-text-simple
        [field]="titleField"
        [preSelectItem]="snippet.title"
        (itemSelected)="itemSelected($event.newValue, shortIdField, 'title')">
      </field-type-text-simple>
    </div>
  </div>
  <div class="common-modal__footer">
    <button
      class="common-button__text-border"
      (click)="handleDismiss()">
      <span
        class="common-button__text-title"
        afTranslate="common.cancel">
        _Cancelar
      </span>
    </button>
    <button
      class="common-button__text"
      (click)="saveSnippet()">
      <span
        class="common-button__text-title"
        afTranslate="common.create">
        _Crear
      </span>
    </button>
  </div>
</div>
<!-- 
<div class="new-snippet-modal">
  <div class="common__modal-header-block">
    <i class="lf-icon-model common__icon-header"></i>
    <span class="common__text-header"
    [afTranslate]="configuration.type === 'new'?'snippets-reusable.new-snippet':'snippets-reusable.edit-snippet'">_Nuevo fragmento</span>
    <i class="lf-icon-close common__icon-close-modal"
    (click)="handleDismiss()"></i>
  </div>
  <div class="new-snippet-modal__block-body"
    [ngClass]="{'new-snippet-modal__block-body--new-fragment': configuration.type === 'new-fragment'}">
    <div class="new-snippet-modal__snippet-form">
      
      }
  </div>
  <div class="common__buttons-block common__buttons-block--modal">
    <button type="reset"
      class="common__button common__button--clean"
      (click)="handleDismiss()"
    [afTranslate]="'common.cancel'">_Cancelar</button>
    <button type="submit"
      class="common__button common__button--active common__button--separating-margin"
      (click)="saveSnippet()"
    [afTranslate]="'common.save'">_Guardar</button>
  </div>
</div>

</div>

 -->